var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playingCardComponent"},[_c('VuePlayingCard',{key:_vm.cardString,attrs:{"width":_vm.width,"height":_vm.height,"signature":_vm.cardString}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }